import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import Imagen1 from "../../../images/modulo11/periodico.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 6.mp3";

const Actividad6 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "juicio" },
    ans2: { value: "", valid: "", correctValue: "Palacio de justicia" },
    ans3: { value: "", valid: "", correctValue: "juzgar" },
    ans4: { value: "", valid: "", correctValue: "delito" },
    ans5: { value: "", valid: "", correctValue: "sentencia" },
  });
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[5];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo11.content[0].activities[6].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[6].path}`,
    titlePrev: `${modulo11.content[0].activities[4].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-10 col-12 p-0">
          <ul className="">
            <li>
              Utiliza las palabras del recuadro para llenar la siguiente
              noticia.{" "}
            </li>
          </ul>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <Card>
            <div className="d-flex justify-content-around flex-wrap">
              <div className="m-1">juzgar</div>
              <div className="m-1">Palacio de Justicia</div>
              <div className="m-1">delito</div>
              <div className="m-1">juicio</div>
              <div className="m-1">sentencia</div>
            </div>
          </Card>
          <div
            className="p-5"
            style={{
              backgroundImage: `url(${Imagen1})`,
              backgroundSize: "100% 100%",
            }}
          >
            <h3 className="text-uppercase">
              ¡Se inicia el juicio a peligrosos delincuentes!
            </h3>
            <p>
              El día de hoy se inicia el{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              a los delincuentes que participaron en el secuestro de un
              comerciante en el barrio de Sol de Oro de la ciudad de Lima. El
              juicio se realizará en el{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
              . Hasta ahí llegaron varios periodistas para entrevistar a la
              jueza encargada de{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />{" "}
              a los delincuentes que cometieron el{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans4.valid
                }
                value={answers.ans4.value}
                onChange={(event) => handleAnswers(event, "ans4")}
              />{" "}
              . Se espera que se dicte una{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans5.valid
                }
                value={answers.ans5.value}
                onChange={(event) => handleAnswers(event, "ans5")}
              />{" "}
              adecuada y se haga justicia.
            </p>
          </div>
        </div>
      </div>

      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo11.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>
      <GuiaDocente>
        <p>
          Lea las indicaciones, las palabras y el texto. Ayude a completar la
          actividad. Si no recuerdan los signifcados de las palabras, pueden
          revisarlos en las actividades 4 y 5.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
